// store.js
import React, { createContext, useReducer } from 'react';
import * as R from 'ramda';

const initialState = {
	error: {
		show: false,
		e: ''
	},
	auth: { session: null },
	fullScreenDialog: {
		open: false,
		dlgCmp: null
	}
};
const store = createContext(initialState);
const { Provider } = store;

const updateState = (state, section, fn) => ({
	...state,
	[section]: R.mergeDeepRight(
		state[section],
		R.is(Function, fn) ? fn(state[section]) : fn
	)
});

const StateProvider = ({ children }) => {
	const [state, dispatch] = useReducer((state, action) => {
		switch (action.type) {
			case 'set session':
				return updateState(state, 'auth', {
					session: action.session
				});
			case 'post error':
				return updateState(state, 'error', {
					show: true,
					e: action.e,
					severity: 'error'
				});
			case 'post success':
				return updateState(state, 'error', {
					show: true,
					e: action.message,
					severity: 'success'
				});
			case 'hide error':
				return updateState(state, 'error', {
					show: false,
					e: {},
					severity: ''
				});
			case 'open dialog':
				return updateState(state, 'fullScreenDialog', () => ({
					open: true,
					title: action.title,
					dlgCmp: action.dlgCmp
				}));

			case 'close dialog':
				return updateState(state, 'fullScreenDialog', () => ({
					title: '',
					open: false,
					dlgCmp: null
				}));

			default:
				throw new Error('Unknown store action');
		}
	}, initialState);

	return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
